import React, { useEffect, useState } from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

import axios from "axios";
import "../Form.css";
import { Popup } from "../../../Utils/Alert";
import {
  tempLayer,
  zoomToGeojson,
  zoomToYapiAdres,
} from "../../Map/Layers/tempLayer";
import { MunicipalityNaneFrontSetting } from "../../../config";

export default function AdresArama() {
  const [readyToShow, setReadyToShow] = useState(true);
  const [ilceler, setIlceler] = useState([]);
  const [mahalleler, setMahalleler] = useState([]);
  const [yollar, setYollar] = useState([]);
  const [kapilar, setKapilar] = useState([]);
  const [ickapilar, setIckapilar] = useState([]);

  const [canSubmit, setCanSubmit] = useState(true); // FALSE İSE, BUTON AKTİF HALE GELİR.

  const [reRender, setReRender] = useState(0);

  const MySwal = withReactContent(Swal);

  const getInfosFromNode = async () => {
    console.log(
      MunicipalityNaneFrontSetting.nodeURL + "adres/get/ilce",
      "burayagircek"
    );
    await axios
      .get(MunicipalityNaneFrontSetting.nodeURL + "adres/get/ilce")
      .then((res) => {
        console.log(res.data, "res.data");
        setIlceler(res.data.rows);
      });
    setReadyToShow(true);
  };

  const onChangeIlce = async (ilceKodu) => {
    setCanSubmit(true);
    document.getElementById("mahalleler").value = "0";
    document.getElementById("yollar").value = "0";
    document.getElementById("kapilar").value = "0";
    document.getElementById("ickapilar").value = "0";

    document.getElementById("mahalleler").disabled = true;
    document.getElementById("yollar").disabled = true;
    document.getElementById("kapilar").disabled = true;
    document.getElementById("ickapilar").disabled = true;

    zoomToGeojson(ilceler.find((d) => d.kod == ilceKodu).geojson, false);

    await axios
      .get(
        MunicipalityNaneFrontSetting.nodeURL + "adres/get/mahalle/" + ilceKodu
      )
      .then((res) => {
        document.getElementById("mahalleler").disabled = false;
        setMahalleler(res.data.rows);
      })
      .catch((err) => {
        alert("Mahalle Bilgileri Getirilemedi.");
        console.log(err);
        return;
      });
    setReRender(Math.random());
  };

  const onChangeMahalle = async (mahKodu) => {
    setCanSubmit(true);
    document.getElementById("yollar").value = "0";
    document.getElementById("kapilar").value = "0";
    document.getElementById("ickapilar").value = "0";
    document.getElementById("yollar").disabled = true;
    document.getElementById("kapilar").disabled = true;
    document.getElementById("ickapilar").disabled = true;

    zoomToGeojson(mahalleler.find((d) => d.kod == mahKodu).geojson, false);

    await axios
      .get(MunicipalityNaneFrontSetting.nodeURL + "adres/get/csbm/" + mahKodu)
      .then((res) => {
        console.log(res.data, "onchangemahalleeee");
        document.getElementById("yollar").disabled = false;
        const sorted = res.data.rows.sort((a, b) =>
          a.ad.localeCompare(b.ad, "tr", { sensitivity: "base" })
        );

        setYollar(sorted);
      })
      .catch((err) => {
        alert("Yol Bilgileri Getirilemedi.");
        console.log(err);
        return;
      });
  };

  const onChangeYol = async (yolKodu) => {
    console.log(yolKodu, "yol kodu");
    setCanSubmit(true);
    axios
      .get(
        MunicipalityNaneFrontSetting.nodeURL +
          "adres/get/csbm/geometry/" +
          yolKodu
      )
      .then((res) => {
        // console.log(res.data.rows[0].geom, "yol bilgileri ")
        if (res.data.length !== 0) {
          zoomToGeojson(res.data.rows[0].geom, false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    document.getElementById("kapilar").value = "0";
    document.getElementById("ickapilar").value = "0";
    document.getElementById("ickapilar").value = "0";
    document.getElementById("kapilar").disabled = true;
    document.getElementById("ickapilar").disabled = true;

    let mahKodu = document.getElementById("mahalleler").value;

    await axios
      .get(
        MunicipalityNaneFrontSetting.nodeURL +
          "adres/get/dis_kapilar/" +
          yolKodu +
          "/" +
          mahKodu
      )
      .then((res) => {
        console.log("yolKodu", res.data.rows);
        // console.log(res.data)
        document.getElementById("kapilar").disabled = false;
        setKapilar(res.data.rows);
      })
      .catch((err) => {
        alert("Yol Bilgileri Getirilemedi.");
        console.log(err);
        return;
      });
  };

  const onChangeDisKapiNo = async (kapiKodu) => {
    console.log(kapiKodu, "kapikodu");
    document.getElementById("ickapilar").value = "0";
    document.getElementById("ickapilar").disabled = true;

    zoomToYapiAdres(
      kapilar.find((kapi) => kapi.kod == kapiKodu).geojson,
      kapilar.find((kapi) => kapi.kod == kapiKodu).yapi_geojson
    );
    await axios
      .get(
        MunicipalityNaneFrontSetting.nodeURL +
          "adres/get/ic_kapilar/" +
          kapiKodu
      )
      .then((res) => {
        document.getElementById("ickapilar").disabled = false;
        setIckapilar(res.data.rows);
        console.log(res.data, "ickapi");
      })
      .catch((err) => {
        alert("İç Kapı Numaraları Getirilemedi.");
        console.log(err);
        return;
      });
    setCanSubmit(false);
  };

  const onChangeIcKapıNo = async (icKapiKodu) => {
    console.log(icKapiKodu);
    setCanSubmit(false);
  };

  const onClickAdresTespitBelgesi = () => {
    let ilceInput = document.getElementById("select-state");
    let mahInput = document.getElementById("mahalleler");
    let yolInput = document.getElementById("yollar");
    let disKapi = document.getElementById("kapilar");
    let icKapiNo = document.getElementById("ickapilar");
    // string ilceAdi, string kapiNo, string numKN,  string ickapino
    let katNo = icKapiNo.value.split("/")[0];
    console.log(katNo, "kat");
    let icKapi = icKapiNo.value.split("/")[1];
    console.log(icKapi, "ickapi");
    let json = {
      kullanici_ilce_label: null,
      diskapi: disKapi.value,
      ickapi: icKapiNo.value,
      eski_adres: "",
    };
    console.log(json, "json");
    let str = `${MunicipalityNaneFrontSetting.nodeURL}pdfSorgu/get/adres/tespit?`;
    Object.keys(json).map((d, i) => {
      console.log(d, "22222adres");
      //console.log(d, "dcc")
      return (str = `${str}${d}=${json[d]}&`);
    });
    Popup(
      <iframe style={{ height: "70vh", width: "100%" }} src={str}></iframe>,
      { width: "950px" }
    );
  };

  useEffect(() => {
    console.log("adddd");
    //MyMap.addLayer(tempLayer)
    getInfosFromNode();
    return () => {
      //tempLayer.getSource().clear()
      //MyMap.removeLayer(tempLayer)
    };
  }, []);

  return (
    <>
      {readyToShow ? (
        <div className="row">
          <div id="adresArama">
            <div className="row">
              <div className="col-3" style={{ marginLeft: "10px" }}>
                İlçe
              </div>
              <div className="col-8">
                <select
                  id="select-state"
                  className="form-control form-control-sm form-select"
                  onChange={(e) => onChangeIlce(e.target.value)}
                >
                  <option selected disabled value="0">
                    Seçiniz
                  </option>
                  {ilceler.map((d, i) => {
                    return (
                      <option key={i} value={d.kod}>
                        {d.ad}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-3" style={{ marginLeft: "10px" }}>
                Mahalle
              </div>
              <div className="col-8">
                <select
                  id="mahalleler"
                  disabled={true}
                  className="form-control form-control-sm form-select"
                  onChange={(e) => onChangeMahalle(e.target.value)}
                >
                  <option selected disabled value="0">
                    Seçiniz
                  </option>
                  {mahalleler.map((d, i) => {
                    return (
                      <option key={i} value={d.kod}>
                        {d.ad}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-3" style={{ marginLeft: "10px" }}>
                CSBM
              </div>
              <div className="col-8">
                <select
                  id="yollar"
                  disabled={true}
                  className="form-control form-control-sm form-select"
                  onChange={(e) => onChangeYol(e.target.value)}
                >
                  <option selected disabled value="0">
                    Seçiniz
                  </option>
                  {yollar.map((d, i) => {
                    // console.log(d, "yol verileri")
                    return (
                      <option key={i} value={d.maks_kimlik_no}>
                        {d.ad}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-3" style={{ marginLeft: "10px" }}>
                Dış Kapı
              </div>
              <div className="col-8">
                <select
                  id="kapilar"
                  disabled={true}
                  className="form-control form-control-sm form-select"
                  onChange={(e) => onChangeDisKapiNo(e.target.value)}
                >
                  <option selected disabled value="0">
                    Seçiniz
                  </option>
                  {kapilar.map((d, i) => {
                    return (
                      <option key={i} value={d.kod}>
                        {d.ad}/{d.kapitiptxt}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-3" style={{ marginLeft: "10px" }}>
                İç Kapı
              </div>
              <div className="col-8">
                <select
                  id="ickapilar"
                  disabled={true}
                  className="form-control form-control-sm form-select"
                  onChange={(e) => onChangeIcKapıNo(e.target.value)}
                >
                  <option selected disabled value="0">
                    Seçiniz
                  </option>
                  {ickapilar.map((d, i) => {
                    console.log(d, "ickapilar");
                    return (
                      <option key={i} value={d.adresno}>
                        {d.ickapino ? d.ickapino : ""}/Kat No:{d.katno}/Adres
                        No:{d.adresno}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-12 d-flex justify-content-end">
                <button
                  className="btn btn-warning btn-sm"
                  disabled={canSubmit}
                  style={{ margin: "10px" }}
                  id="adresTespitBtn"
                  onClick={() => onClickAdresTespitBelgesi()}
                >
                  Adres Tespit Belgesi
                </button>
              </div>

              <div className="col-12" style={{ display: "none" }}>
                <center>
                  <br />
                  <b>Arama Sonuçları</b>
                  <hr style={{ margin: "2px" }} />
                </center>
              </div>

              <div className="col-12" style={{ display: "none" }}>
                <table className="table table-sm table-striped">
                  <tr>
                    <td>
                      <center>
                        <button className="btn bg-light btn-sm btn-block">
                          <i className="fas fa-search-location fa-2x"></i>
                        </button>
                      </center>
                    </td>
                    <td style={{ width: "80%" }}>
                      Atatürk Mahallesi, Çınarlı Çeşme Sokak. Yonca Apt
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <center>
                        <button className="btn bg-light btn-sm btn-block">
                          <i className="fas fa-search-location fa-2x"></i>
                        </button>
                      </center>
                    </td>
                    <td style={{ width: "80%" }}>
                      Atatürk Mahallesi, Çınarlı Çeşme Sokak. Yonca Apt
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <center>
                        <button className="btn bg-light btn-sm btn-block">
                          <i className="fas fa-search-location fa-2x"></i>
                        </button>
                      </center>
                    </td>
                    <td style={{ width: "80%" }}>
                      Atatürk Mahallesi, Çınarlı Çeşme Sokak. Yonca Apt
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <i>Yükleniyor</i>
      )}
    </>
  );
}
